import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { appAccessGuard } from './pages/core/shared/guards/app-access.guard';
import { RolesMsalGuard } from './pages/core/shared/guards/roles-msal.guard';
import { mobileNavigationGuard } from './pages/core/shared/guards/mobile-navigation.guard';

const routes: Routes = [
  {
    path: 'external',
    loadChildren: () => import('./pages/external/external.module').then(m => m.ExternalModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule),
    canActivate: [appAccessGuard],
    canActivateChild: [mobileNavigationGuard]
  },

  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
    canActivate: [RolesMsalGuard],
    canActivateChild: [mobileNavigationGuard],
    data: { allowedRoles: ['admin', 'superadmin'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
